import React, {
  useContext,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";
import Button from "components/button/button";
import { FaEllipsisH } from "react-icons/fa";
import { IoEllipse } from "react-icons/io5";
import { BsGlobe2, BsExclamationDiamondFill } from "react-icons/bs";
import { embedVideo } from "utils/constant";
import { AiFillPushpin } from "react-icons/ai";
import UserTagIconSVG from "assets/svg/user-tag-icon";
import { Context } from "context/context";
import { formatDate, isImgUrl, removePostalCode,currentLang, toTitleCase } from "utils/utils";
import ReactPlayer from "react-player";
import _ from "lodash";
import Popup from "reactjs-popup";
import OptionListItem from "./more-option/option-list-item";
import { gsap } from "gsap";
import AudioPlayer from "./media-button/audio-player";
import LazyImage from "./LazyImage";
import { imageSquareOrPortrait, profileTag } from "utils/utils";
import { useMilestones } from "redux/modules/milestone/hooks";
import PrivacyBadge from "components/milestonelist/privacyBadge";
import {
  DATE_NEWEST_TO_OLDEST,
  DATE_OLDEST_TO_NEWEST,
  JOB_ROLE,
} from "constants/options";
import CharacterLimit from "./character-limit";
import ToolTip from "components/tootltip/tootltip";
import { CoverPlaceholderMilestone } from "constants/images";
import MediaButton from "components/button/media-button";
import { useWindowDimensions } from "utils/customhooks";
import Collapsible from "components/collapsible";
import { useTranslation } from "react-i18next";
import { CgArrowsExchangeV } from "react-icons/cg";
import PinnedReorder from "./pinned-reorder";
import { useDialogHook } from "utils/customhooks";
import { useLocation, useHistory } from 'react-router-dom';
import { DetailedTagViewCard } from "./detailed-tag-view-card";
import TutorialVid from "components/get-started/components/tutorial";
import DetailedViewEdit from "./quick-edit/detailed-view-edit";
import DemoQuickEdit from "./quick-edit/demo-quick-edit.js";

export function findScrollableParent(element) {
  let parent = element.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    const overflowY = style.overflowY;
    const overflow = style.overflow;

    if (
      (overflowY === 'auto' || overflowY === 'scroll') ||
      (overflow === 'auto' || overflow === 'scroll')
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return window; // fallback if no scrollable parent found
}

export function scrollToElementWithOffset(target, offset = 50) {
  const scrollableParent = findScrollableParent(target);

  if (scrollableParent === window) {
    const y = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: y - offset, behavior: 'smooth' });
  } else {
    const parentTop = scrollableParent.getBoundingClientRect().top;
    const targetTop = target.getBoundingClientRect().top;
    const scrollPosition = scrollableParent.scrollTop + (targetTop - parentTop) - offset;
    scrollableParent.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  }
}

const DetailedViewCard = ({
  title,
  dateNote,
  viewUrl,
  date,
  people,
  url = "",
  description,
  privacy,
  isAdultContent,
  category, 
  categories=[],
  buttons = [],
  positions = [],
  platform,
  location,
  isYourProfile,
  permission,
  profile,
  featured,
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onEdit = () => {},
  onDelete = () => {},
  //
  onShare = () => {},
  share,
  closeModal = () => {},
  onReport = () => {},
  hide = () => {},
  handlePopup = () => {},
  activePopup = {},
  group = null,
  setActivePopup = () => ({ group: null, index: null }),
  indexPopUp = -1,
  organizeBy = null,
  mention_names = {},
  dataId,
  translateMilestone=()=>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
  showTutMilestone=null,
  setTutMile,
  countMile = 1,
  setQuickEditId,
  quickEditId,
  cancelEdit,
  userData,
  updateMilestonesState,
  key,
  detailedView=false,
  tagView=false,
  onRemoveTag = () => {},
  mt = 'mt-4 2sm:mt-4.5 3md:mt-6',
  milestoneEmbed = () => {},
  showItemList = true,
  gsapLabel="milestone-item",
  setOnboardingDone=()=>{}
}) => {
  const { translation = {} } = featured;
  const { showMaturedContent, setShowMaturedContent } = useContext(Context);
  const [showMoreOption, setShowMoreOption] = useState(false);
  const [showAllMedia, setShowAllMedia] = useState(false);
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [showIndPlayer, setShowIndPlayer] = useState(null);
  const [hideMusic, setHideMusic] = useState(false);
  const [imageHeight, setImageHeight] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const listenRef = useRef();
  const optionRef = useRef();
  const contentRef = useRef();
  const optionListRef = useRef();
  const { isMobile } = useWindowDimensions();
  const [desc, setDescription] = useState(() => {
    const lang = currentLang();
    const t = translation?.[lang];
    return t?.description || description;
  });
  const quickEditDemo = useDialogHook(DemoQuickEdit);
  const loc = useLocation();
  const history = useHistory();
  const {t} = useTranslation();
  const tutorialVid = useDialogHook(TutorialVid);


  // useEffect(() => {
  //   const search = new URLSearchParams(loc.search);
  //   const focusMiletone = search.get("focusMilestone");
  //   if(focusMiletone) {
  //     const targetId = Number(focusMiletone);
  //     const currentId = Number(dataId);
  //     if(targetId === currentId) {
  //       const element = document.querySelector(`[data-milestone-id="${targetId}"]`);
  //       // element.scrollIntoView();
  //       scrollToElementWithOffset(element, 120); // scroll with 50px top space
  //       const pathWithoutSearch = loc.pathname;
  //       history.replace(pathWithoutSearch);
  //     }
  //   }
  // }, [loc, dataId, history]);

  useEffect(()=>{
        const currentId = Number(dataId); 
        if(currentId === showTutMilestone){
          const btn_milestone = document.querySelector(`[data-milestone-id-btn="${showTutMilestone}"]`)
          scrollToElementWithOffset(btn_milestone, 250);
          let patentWin = findScrollableParent(btn_milestone);
          tutorialVid({
            position:btn_milestone.getBoundingClientRect(),
            parent:patentWin.getBoundingClientRect(),
            count: countMile,
            onEdit,
            onDelete:()=>onDelete(true), //demo delete nothing
            onShare,
            onQuickEdit: ()=>{
              quickEditDemo({
                  title,
                  date,
                  buttons,
                  positions,
                  milestone:featured,
                  profile,
                  cancelEdit,
                  url,
                  userData,
                  group,
                  updateMilestonesState,
                  location,
                  platform
              })
            }
          }
            ,(callback)=>{
            setOnboardingDone()
            setTutMile(null);
            http.put(`public/profiles/tutorialMilestone/${profile.id}`);
          })
        } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[showTutMilestone,dataId])


  const [isVisible, setIsVisible] = useState(-1);
  const { setPLayMusic } = useMilestones();
  const { http } = global.services;
  // ================== handleMedia ================================
  const handleMedia = async (media) => {
    http.post(`button-click/`, { id: media.id });

    let url = "";
    let orientation = "Landscape";
    let fileExt = "";

    if (
      media.sub_type.name === "Multiple Images" ||
      media.sub_type.name === "Single Image"
    ) {
      onViewImage(title, media, media["media"]);
    } else {
      if (media.url) {
        url = media.url;
        orientation = media?.orientation;
      } else {
        url = media["media"][0]["media"]["url"];
        orientation = media["media"][0]["media"]["orientation"];
        fileExt = media["media"][0]["media"]["file_extension"];
      }

      if (await isImgUrl(url)) {
        onViewImage(title, media, media["media"]);
      } else if (ReactPlayer.canPlay(url)) {
        onWatchMedia(title, url, orientation);
      } else if (fileExt === "pdf") {
        handleViewPdf(title, url,media["media"], media);
        hide();
      } else if (media.sub_type.name === "Link") {
        window.open(url, "_blank");
      } else {
        if (embedVideo.find((v) => url.includes(v.value)) || ReactPlayer.canPlay(url)) {
          onWatchMedia(title, url, orientation);
        } else {
          window.open(url, "_blank");
        }
      }
    }
  };
  // ================== useEffect ================================
  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, [showAudioPlayer]);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-item",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  useEffect(() => {
    (async () => {
      if (!url) {
        setImageUrl(null);
        setImageHeight(300);
        return;
      }
      const res = await imageSquareOrPortrait(url);
      const element = contentRef.current;
      if (res === "portrait" && element) {
        if (element) {
          if (element.offsetHeight < 300) {
            setImageHeight(300);
          } else {
            setImageHeight(element.offsetHeight);
          }
          setImageUrl(url);
        }
      } else {
        setImageUrl(url);
      }
    })();
  }, [url]);

  useEffect(() => {
    if (!_.isEmpty(mention_names)) {
      let newDesc = profileTag(mention_names, description);
      setDescription(newDesc);
      return;
    }
    setDescription(() => {
    const lang = currentLang();
    const t = translation?.[lang];
    return t?.description || description;
  }); 
  }, [translation, description, mention_names]);

  return (
    <div className={`${gsapLabel} w-full bg-siteBg relative pb-2 2sm:pb-0 ${mt}`} data-milestone-id={dataId || "no-id"} key={key}>
        {
          featured.id === quickEditId ?
            <DetailedViewEdit
              buttons={buttons}
              title={title}
              description={description}
              positions={positions}
              milestone={featured} 
              date={date}
              profile={profile}
              cancelEdit={cancelEdit}
              url = {url}
              viewUrl = {viewUrl}
              userData={userData}
              updateMilestonesState={updateMilestonesState}
              group={group}
              platform={platform}
              location={location}
          /> :
          <div
            className={`w-full flex flex-col 2md:flex-row space-y-0.5 2md:space-x-0.5 2md:space-y-0  ${
              imageUrl ? "min-h-300" : "min-h-300"
            }`}
          >
            <div className="flex flex-col 2md:flex-row 2md:space-x-"></div>
            {imageUrl ? (
              <div className="relative bg-white h-auto 2md:min-h-[300px] 2md:w-[300px]">
                {/* thumbnail */}
                <LazyImage
                  viewUrl={viewUrl}
                  source={imageUrl}
                  customClassName="w-full md:max-w-[300px] h-auto 2md:max-h-[300px]"
                  imageHeight={imageHeight}
                  withContainer="w-full 2md:w-[300px]"
                />
              </div>
            ) : (
              <div className="relative min-h-[300px] 2md:w-[300px] flex items-center justify-center bg-[#e9e9e9]">
                <div className="w-full 2md:w-[300px] flex items-center justify-center h-full bg-[#e9e9e9]">
                  <img
                    src={CoverPlaceholderMilestone}
                    alt="Milestone"
                    className="h-[111px] w-[113px]"
                  />
                </div>
              </div>
            )}
            <div
              className={`relative bg-white 
                        lg:mt-0 lg:py-4 lg:px-7.5 
                        sm:px-7 sm:pb-7 sm:pt-7
                        px-3 pb-6 pt-4 p-7 w-full ${
                          imageUrl
                            ? "width-responsive-detailed-view"
                            : "width-responsive-detailed-view-full"
                        }`}
              ref={contentRef}
            >
              {/* content */}
              <div className="w-full flex justify-between h-full">
                <div className="flex items-center w-full h-full">
                  <div className="w-full">
                    {/* title */}
                    <div className="flex gap-4 justify-between">
                      <div className="flex items-center space-x-1 flex-wrap">
                        <p className="text-base 2sm:text-xl 3md:text-2xl text-lightBlack font-medium tracking-tighter leading-5 2sm:leading-7">
                          {toTitleCase(translation?.[currentLang()]?.[title] || title)}
                        </p>
                      </div> 
                    </div>

                    {/* category */}
                    {/* <div className="items-center space-x-5 flex-wrap mb-1 hidden 3md:flex">
                      <p className="px-1.5 py-1 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md">
                        {category}
                      </p>
                    </div> */}
                    {/* details */}
                    <div className="w-full mt-0 2sm:mt-1.5">
                      <div className="w-full text-[11px] 2sm:text-sm 3md:text-base text-darkerGray font-medium 3md:leading-[16px] inline-flex items-center flex-wrap gap-x-3 gap-y-1">
                        <div className="item-col-lg">
                          <p>
                            {date}
                            {dateNote && dateNote !== 'null' ? (
                              <span className="ml-1">{`(${translation?.[currentLang()]?.[dateNote] || dateNote})`}</span>
                            ) : ''}
                            {/* <span className="pl-2 inline-flex items-center align-middle gap-2">
                              <PrivacyBadge
                                privacy={privacy}
                                isYourProfile={isYourProfile}
                              />
                            </span> */}
                          </p>
                        </div>
                        {
                          isYourProfile && 
                          <div className="item-col-lg">
                            <PrivacyBadge
                                privacy={privacy}
                                isYourProfile={isYourProfile}
                              />
                          </div>
                        }
                        {/* <p className="flex items-center capitalize">
                          {privacy === "public" ? (
                            <BsGlobe2 className="mr-1.5" />
                          ) : (
                            <BsExclamationDiamondFill className="mr-1.5" />
                          )}
                          {privacy}
                        </p> */}
                      
                        {isAdultContent && (
                          <div className="item-col-lg">
                            <span className="text-red flex flex-row items-center font-medium">
                              <BsExclamationDiamondFill className="mr-1.5" /> {t('adultContent')}
                            </span>
                          </div>
                        )}
                        {people && (
                          <div className="item-col-lg">
                            {/* <p className="hidden md:block">
                              <IoEllipse className="w-1 h-1" />
                            </p> */}
                            <p className="hidden md:flex items-center">
                              <UserTagIconSVG className="mr-1.5" />
                              {people}
                            </p>
                          </div>
                        )}
                        <>
                          {
                            categories.map((item,index)=>{
                              return(
                                  <p key={index} className="px-1.5 py-1 block 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                                    {(!profile?.dateFormat && item[currentLang()] === 'Theatre') ? 'Theater' : item[currentLang()] ||item.name}
                                  </p>
                              )
                            })
                          }
                        </> 
                      </div>
                      {/* <div className="inline-flex flex-wrap 2sm:hidden gap-2">
                        {
                          categories.map((item,index)=>{
                            return( 
                              <p key={index.name} className="px-1.5 py-1 block  3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                              {item[currentLang()] || item.name}
                              </p> 
                            )
                          })
                        }
                      </div> */}
                    </div>
                    {/* Author Name and description */}
                    <div className="w-full my-0 mt-1">
                      <p className="text-[13px] 2sm:text-sm 3md:text-base font-bold 3md:leading-6 mt-0 2sm:mt-1.5">
                        <span>
                          {positions
                            .map((p) => {
                              const _pos = [p.position[currentLang()]?.trim() || p.position.name?.trim()];
                              if (p.description)
                                _pos.push(removePostalCode(p.description).trim());
                              return _pos.join(" - ");
                            })
                            .join(", ")
                            .trim()}
                        </span>
                        {/* {positions.map((p, i) => (
                          <span key={i}>
                            {p.position.name}
                            {p.description && ` - ${removePostalCode(p.description)}`}
                            {i < positions.length - 1 && ", "}
                          </span>
                        ))} */}
                        <span className="break-anywhere pr-0 mr-0 pl-[0.15rem]">
                          {platform && (
                            <>
                              (
                              {translation?.[currentLang()]?.[platform] || platform}
                              {(location && location !== 'null') && ` - ${translation?.[currentLang()]?.[location] || location}`}
                              )
                            </>
                          )}
                        </span>
                      </p>
                      <CharacterLimit html={desc} />
                    </div>
                    {/* buttons */}
                    {!_.isEmpty(buttons) && (
                      <div className="w-full mt-3 flex flex-col md:grid md:grid-cols-[1fr] gap-3">
                        <div className="w-full flex flex-col md:grid md:grid-cols-[repeat(3,1fr)_90px] gap-3">
                          {buttons
                            .slice(
                              0,
                              showAllMedia ? buttons.length : !isMobile ? 3 : 2
                            )
                            .map((btn, index) => {
                              if (btn.sub_type.name === "Audio File"  || btn.type.name === "Listen") {
                                return (
                                  <div
                                    className="relative"
                                    style={{ gridColumn: (index % 3) + 1 }}
                                  >
                                    <MediaButton
                                      key={index}
                                      buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                                      buttonData={btn}
                                      buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                      buttonRadius="6px"
                                      buttonClass={`relative rounded-md py-3 px-4 xl:px-0 border-2 border-gray bg-white hover:bg-thBg w-full h-full`}
                                      onClick={() => {
                                        setPLayMusic(btn);
                                        handlePopup();
                                        setIsVisible(buttons.id);
                                        setShowAudioPlayer((prev) => !prev);
                                        if(!isMobile) setShowIndPlayer(btn.id);
                                        http.post(`button-click/`, { id: btn.id });
                                      }}
                                    />
                                    {activePopup.group === group &&
                                      activePopup.index === indexPopUp &&
                                      btn.id === showIndPlayer && (
                                        <div
                                          className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                          ref={listenRef}
                                        >
                                          <AudioPlayer
                                            media={btn}
                                            hide={hideMusic}
                                            onClosePlayer={() => {
                                              setActivePopup({
                                                group: null,
                                                index: null,
                                              });
                                              setShowIndPlayer(null);
                                            }}
                                          />
                                        </div>
                                      )}
                                    {organizeBy === JOB_ROLE &&
                                      btn.id === showIndPlayer && (
                                        <div
                                          className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                          ref={listenRef}
                                        >
                                          <AudioPlayer
                                            media={btn}
                                            hide={hideMusic}
                                            onClosePlayer={() => {
                                              setIsVisible(null);
                                              setShowIndPlayer(null);
                                            }}
                                          />
                                        </div>
                                      )}
                                  </div>
                                );
                              }
                              return (
                                <div style={{ gridColumn: (index % 3) + 1 }}>
                                  <MediaButton
                                    buttonData={btn}
                                    key={index}
                                    buttonName={btn?.translation?.[currentLang()]?.[btn.label] || btn.label}
                                    buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                    buttonRadius="6px"
                                    buttonClass="relative rounded-md py-3 px-4   xl:px-0 border-2 border-gray bg-white bg-white hover:bg-thBg w-full h-full"
                                    onClick={() => handleMedia(btn)}
                                  />
                                </div>
                              );
                            })}
                          { buttons.length > (!isMobile ? 3 : 2) && (
                            <button
                              className={`rounded-md min-h-[2.875rem] md:col-start-4 md:row-start-1 md:row-span-1 ${
                                showAllMedia
                                  ? "bg-lightBlack text-white"
                                  : "bg-thBg"
                              }`}
                              onClick={() => setShowAllMedia(!showAllMedia)}
                            >
                              {showAllMedia ? t("hide") : `+${buttons.length - (!isMobile ? 3 : 2)}`}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {
                  showItemList &&
                    <Popup
                        ref={optionRef}
                        position="bottom right"
                        open={showMoreOption}
                        onClose={() => setShowMoreOption(false)}
                        arrow={false}
                        contentStyle={{
                          marginTop: 10,
                          marginLeft: 5,
                          zIndex: 9999,
                        }}
                        trigger={
                          <button
                            className="bg-thBg w-6 h-6 2sm:w-10 2sm:h-10 rounded-md inline"
                            onClick={() => setShowMoreOption((open) => !open)}
                            data-milestone-id-btn={dataId || "no-id"}
                          >
                            <FaEllipsisH className="m-auto text-1xs md:text-base" />
                          </button>
                        }
                      >
                        <OptionListItem
                          ref={optionListRef}
                          {...{
                            isYourProfile,
                            onEdit,
                            onDelete,
                            permission,
                            onShare,
                            share,
                            closeModal,
                            onReport,
                            profile,
                            featured,
                            hide,
                            translateMilestone,
                            onCopyLink,
                            onAnalytics,
                            group,
                            setQuickEditId,
                            isMobile,
                            milestoneEmbed,
                            tagView,
                            onRemoveTag
                          }}
                          closeMoreOption={() => {
                            setShowMoreOption(false);
                            optionRef.current.close();
                          }}
                          title={translation?.[currentLang()]?.[title] || title}
                          detailedView={detailedView}
                        />
                      </Popup>
                }
              </div>
            </div>
          </div>
        }
      
    </div>
  );
};
export default function DetailedViewMilestones({
  isYourProfile,
  featured = {},
  current = [],
  past = [],
  pin = [],
  upcoming = [],
  tagged = [],
  tagView = false,
  showFeatured,
  permission,
  profile,
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  togglePrivacyTaggedMilestone = () => {},
  onEdit = () => {},
  onDelete = () => {},
  onShare = () => {},
  onReport = () => {},
  onRemoveTag = () => {},
  milestone_owner,
  translateMilestone= () =>({milestone:null,section:null,lang:"en"}),
  onCopyLink = () => {},
  onAnalytics = () => {},
  showTutMilestone,
  setTutMile,
  userData={},
  updateMilestonesState,
  detailedView=false,
  milestoneEmbed=()=>{},
  setOnboardingDone=()=>{}
}) {

  const pinnedOrder =useDialogHook(PinnedReorder)
  const { http } = global.services;
  const { organizeBy } = useMilestones();
  const { t } = useTranslation();
  // State to track the active pop-up's group and index
  const [activePopup, setActivePopup] = useState({ group: null, index: null });
  const [quickEditId, setQuickEditId] = useState(null);
  let totalMile = current.length + past.length + upcoming.length;

  const featuredThumbnail = featured.thumbnail
    ? featured.thumbnail.webp_url || featured.thumbnail.url
    : null;
  const featuredDate = formatDate(featured, profile?.dateFormat, t);
  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-title",
      {
        y: -20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  const handlePopup = (group, index) => {
    // Toggle pop-up visibility based on group and index
    if (activePopup.group === group && activePopup.index === index) {
      setActivePopup({ group: null, index: null });
    } else {
      setActivePopup({ group, index });
    }
  };
  
  const customHandle = ()=>{ 
    pinnedOrder({milestones:pin,profile},(callback)=>{
      if(callback?.success){
        return;
      }
    })
  }

  // Set a tagged milestone's visibility for THIS profile only. Uses the tag
  // decision endpoint (not toggle-privacy) so it never changes the original
  // milestone's own privacy — that belongs to the tagger.
  const handleDecide = (milestone, isPrivate) => {
    try {
      http.put(`public/milestone-tag/${milestone.id}/${profile.id}/decision`, { is_private: isPrivate });
      const updated = { ...milestone, is_private: isPrivate, privacy: isPrivate ? "Private" : "Public" };
      togglePrivacyTaggedMilestone({ data: updated });
    } catch (error) {

    }
  };

  return (
    <>
      {tagView ?
        <div className="w-full container-max-width mt-4.5 3md:mt-10">
          <Collapsible
            hidden={tagged.length === 0}
            title={() =>
              tagged.length > 0 && (
                <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                  {organizeBy === DATE_NEWEST_TO_OLDEST
                    ? DATE_NEWEST_TO_OLDEST
                    : organizeBy === DATE_OLDEST_TO_NEWEST
                    ? DATE_OLDEST_TO_NEWEST
                    : t("tagged")}
                </p>
              )
            }
            content={() => (
              <>
                {tagged.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  const viewUrl = obj.thumbnail ? obj.thumbnail.url : null;

                  return (
                    <DetailedTagViewCard
                      dataId={obj.id}
                      profile={obj.profile}
                      featured={obj}
                      key={`tagged-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || viewUrl}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      location={obj.location}
                      description={obj.description}
                      privacy={obj.privacy}
                      isPrivate={obj.is_private}
                      isAdultContent={obj.is_adult_content ? true : false}
                      onDecide={(isPrivate) => handleDecide(obj, isPrivate)}
                      categories={obj?.categories}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "upcoming")}
                      onDelete={(isDemo = false) => onDelete(obj,isDemo)}
                      onRemoveTag={() => onRemoveTag(obj)}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "upcoming")}
                      share={true}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      handlePopup={() => {
                        handlePopup("upcoming", index);
                      }}
                      activePopup={activePopup}
                      group="tagged"
                      setActivePopup={setActivePopup}
                      indexPopUp={index}
                      mention_names={obj.mention_names}
                      userData={userData}
                    />
                  );
                })}
              </>
            )}
          />
        </div>:
  
      <div className="w-full container-max-width px-4 3md:px-0">
        {showFeatured && (
          <div className="w-full container-max-width mb-2">
            {/* <p className="milestone-title px-7.5 3md:px-0 text-lightBlack font-bold text-2xl leading-7.5 tracking-tighter">
            Featured
          </p> */}
            {!_.isEmpty(featured) && (
              <DetailedViewCard
                profile={profile}
                featured={featured}
                url={featuredThumbnail}
                viewUrl={featuredThumbnail || featured.thumbnail.url}
                title={featured.title}
                dateNote={featured.date_note}
                date={featuredDate}
                people={featured.people}
                positions={featured.positions}
                platform={featured.platform}
                location={featured.location}
                description={featured.description}
                privacy={featured.privacy}
                isAdultContent={featured.is_adult_content ? true : false}
                // category={featured?.category?.name}
                categories={featured?.categories}
                buttons={featured.media_type}
                onWatchMedia={onWatchMedia}
                onViewImage={onViewImage}
                handleViewPdf={handleViewPdf}
                onEdit={() => onEdit(featured, "featured")}
                onDelete={(isDemo = false) => onDelete(featured, isDemo)}
                isYourProfile={isYourProfile}
                permission={permission}
                onShare={() => onShare(featured, "featured")}
                onAnalytics={() => onAnalytics(featured)}
                onCopyLink={() => onCopyLink(featured)}
                share={true}
                onReport={() => onReport({...featured, profile:milestone_owner})}
                mention_names={featured.mention_names}
                dataId={featured.id}
                detailedView={detailedView}
                milestoneEmbed={() => milestoneEmbed(featured)}
                setOnboardingDone={setOnboardingDone}
              />
            )}
          </div>
        )}

        <div className="w-full mt-4.5 3md:mt-10">
          <Collapsible
            hidden={pin.length === 0}
            title={() =>
              pin.length > 0 && (
                <div className="flex gap-4 items-center">
                  <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter flex gap-3">
                    <>{t("pinned")}</>
                    <AiFillPushpin className="text-2xl" />
                  </p>
                  {
                    isYourProfile && (
                      <Button
                        icon={<CgArrowsExchangeV className="text-sm"/>}
                        buttonName={t("reorderPinned")}
                        buttonRadius="6px"
                        iconPosition="left"
                        buttonClass="py-2 px-4 bg-gray"
                        buttonTextClass="text-black text-sm font-semibold flex items-center justify-center"
                        onClick={() => customHandle()}
                      />
                    )
                  }
                  
                </div>
              )
            }
            content={() => (
              <>
                {pin.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat,t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  const viewUrl = obj.thumbnail ? obj.thumbnail.url : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      key={`past-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || viewUrl}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      location={obj.location}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      categories={obj?.categories}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "pin")}
                      onDelete={(isDemo = false) => onDelete(obj,isDemo)}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "pin")}
                      share={true}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      handlePopup={() => {
                        handlePopup("pin", index);
                      }}
                      activePopup={activePopup}
                      setActivePopup={setActivePopup}
                      group="pin"
                      indexPopUp={index}
                      mention_names={obj.mention_names}
                      translateMilestone = {translateMilestone}
                      onAnalytics={() => onAnalytics(obj)}
                      onCopyLink={() => onCopyLink(obj)}
                      showTutMilestone={showTutMilestone}
                      setTutMile={setTutMile}
                      setQuickEditId={()=>setQuickEditId(obj.id)}
                      quickEditId={quickEditId}
                      cancelEdit = {()=>{setQuickEditId(null)}}
                      userData={userData}
                      updateMilestonesState={updateMilestonesState}
                      detailedView={detailedView}
                      milestoneEmbed={() => milestoneEmbed(obj)}
                      setOnboardingDone={setOnboardingDone}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-4.5 3md:mt-10">
          <Collapsible
            hidden={upcoming.length === 0}
            title={() =>
              upcoming.length > 0 && (
                <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                  {organizeBy === DATE_NEWEST_TO_OLDEST
                    ? DATE_NEWEST_TO_OLDEST
                    : organizeBy === DATE_OLDEST_TO_NEWEST
                    ? DATE_OLDEST_TO_NEWEST
                    : t("upcoming")}
                </p>
              )
            }
            content={() => (
              <>
                {upcoming.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat, t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  const viewUrl = obj.thumbnail ? obj.thumbnail.url : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      key={`upcoming-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || viewUrl}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      location={obj.location}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      categories={obj?.categories}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "upcoming")}
                      onDelete={(isDemo = false) => onDelete(obj,isDemo = false)}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "upcoming")}
                      share={true}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      handlePopup={() => {
                        handlePopup("upcoming", index);
                      }}
                      activePopup={activePopup}
                      group="upcoming"
                      setActivePopup={setActivePopup}
                      indexPopUp={index}
                      mention_names={obj.mention_names}
                      translateMilestone = {translateMilestone}
                      onAnalytics={() => onAnalytics(obj)}
                      onCopyLink={() => onCopyLink(obj)}
                      showTutMilestone={showTutMilestone}
                      setTutMile={setTutMile}
                      countMile = {totalMile}
                      setQuickEditId={()=>setQuickEditId(obj.id)}
                      quickEditId={quickEditId}
                      cancelEdit = {()=>{setQuickEditId(null)}}
                      userData={userData}
                      updateMilestonesState={updateMilestonesState}
                      detailedView={detailedView}
                      milestoneEmbed={() => milestoneEmbed(obj)}
                      setOnboardingDone={setOnboardingDone}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-4.5 3md:mt-10">
          <Collapsible
            hidden={current.length === 0}
            title={() => (
              <>
                {current.length > 0 && (
                  <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                    {organizeBy === DATE_NEWEST_TO_OLDEST
                      ? DATE_NEWEST_TO_OLDEST
                      : organizeBy === DATE_OLDEST_TO_NEWEST
                      ? DATE_OLDEST_TO_NEWEST
                      : t("current")}
                  </p>
                )}
              </>
            )}
            content={() => (
              <>
                {current.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat, t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  const viewUrl = obj.thumbnail ? obj.thumbnail.url : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      key={`current-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || viewUrl}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      location={obj.location}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      categories={obj?.categories}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "current")}
                      onDelete={(isDemo = false) => onDelete(obj,isDemo)}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "current")}
                      share={true}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      handlePopup={() => {
                        handlePopup("current", index);
                      }}
                      activePopup={activePopup}
                      group="current"
                      setActivePopup={setActivePopup}
                      indexPopUp={index}
                      mention_names={obj.mention_names}
                      translateMilestone = {translateMilestone}
                      onAnalytics={() => onAnalytics(obj)}
                      onCopyLink={() => onCopyLink(obj)}
                      showTutMilestone={showTutMilestone}
                      setTutMile={setTutMile}
                      countMile = {totalMile}
                      setQuickEditId={()=>setQuickEditId(obj.id)}
                      quickEditId={quickEditId}
                      cancelEdit = {()=>{setQuickEditId(null)}}
                      userData={userData}
                      updateMilestonesState={updateMilestonesState}
                      detailedView={detailedView}
                      milestoneEmbed={() => milestoneEmbed(obj)}
                      setOnboardingDone={setOnboardingDone}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
        <div className="w-full mt-4.5 3md:mt-10">
          <Collapsible
            hidden={past.length === 0}
            title={() => (
              <>
                {past.length > 0 && (
                  <p className="milestone-title text-lightBlack font-bold text-base 2sm:text-xl 3md:text-2xl leading-7.5 tracking-tighter">
                    {organizeBy === DATE_NEWEST_TO_OLDEST ||
                    organizeBy === DATE_OLDEST_TO_NEWEST ||
                    past.length <= 0
                      ? ""
                      : t("previous")}
                  </p>
                )}
              </>
            )}
            content={() => (
              <>
                {past.map((obj, index) => {
                  const date = formatDate(obj, profile?.dateFormat, t);
                  const thumbnail = obj.thumbnail
                    ? obj.thumbnail.webp_url || obj.thumbnail.url
                    : null;
                  const viewUrl = obj.thumbnail ? obj.thumbnail.url : null;

                  return (
                    <DetailedViewCard
                      dataId={obj.id}
                      profile={profile}
                      featured={obj}
                      key={`past-${index}-${obj.id}`}
                      details={obj}
                      url={thumbnail}
                      viewUrl={thumbnail || viewUrl}
                      title={obj.title}
                      dateNote={obj.date_note}
                      date={date}
                      people={obj.people}
                      positions={obj.positions}
                      platform={obj.platform}
                      location={obj.location}
                      description={obj.description}
                      privacy={obj.privacy}
                      isAdultContent={obj.is_adult_content ? true : false}
                      // category={obj?.category?.name}
                      categories={obj?.categories}
                      buttons={obj.media_type}
                      onWatchMedia={onWatchMedia}
                      onViewImage={onViewImage}
                      handleViewPdf={handleViewPdf}
                      onEdit={() => onEdit(obj, "past")}
                      onDelete={(isDemo = false) => onDelete(obj,isDemo)}
                      isYourProfile={isYourProfile}
                      permission={permission}
                      onShare={() => onShare(obj, "past")}
                      share={true}
                      onReport={() => onReport({...obj, profile:milestone_owner})}
                      handlePopup={() => {
                        handlePopup("past", index);
                      }}
                      activePopup={activePopup}
                      group="past"
                      setActivePopup={setActivePopup}
                      indexPopUp={index}
                      mention_names={obj.mention_names}
                      translateMilestone = {translateMilestone}
                      onAnalytics={() => onAnalytics(obj)}
                      onCopyLink={() => onCopyLink(obj)}
                      showTutMilestone={showTutMilestone}
                      setTutMile={setTutMile}
                      countMile = {totalMile}
                      setQuickEditId={()=>setQuickEditId(obj.id)}
                      quickEditId={quickEditId}
                      cancelEdit = {()=>{setQuickEditId(null)}}
                      userData={userData}
                      updateMilestonesState={updateMilestonesState}
                      detailedView={detailedView}
                      milestoneEmbed={() => milestoneEmbed(obj)}
                      setOnboardingDone={setOnboardingDone}
                    />
                  );
                })}
              </>
            )}
          />
        </div>
      </div>
        }
    </>
  );
}

export { DetailedViewCard };
